import { isTextAreaElement, TextCounter } from "$lib/core";
import { delegateFocus } from "$lib/core/js/forms";
import { once } from "$lib/core/js/util/once";
import { FormRestructureEvent } from "../core/";

/**
 * @param {HTMLFormElement} form 
 */
export function addTextCounter(form) {
	form.addEventListener("restructure", event => {
		if (!(event instanceof FormRestructureEvent)) return;

		for (const entry of event.added) {
			if (!entry.field) continue;

			for (const textArea of once("webform-counter", "textarea", entry.field, isTextAreaElement)) {

				/** @type {TextCounter?} */
				let counter = null;

				const valMin = textArea.dataset.valMinlengthMin ? Number.parseInt(textArea.dataset.valMinlengthMin) : null;
				const valMax = textArea.dataset.valMaxlengthMax ? Number.parseInt(textArea.dataset.valMaxlengthMax) : null;

				let type = "";
				let min = -1;
				let max = -1;
				let countOverflow = false;

				// .NET asp-validation
				if (valMin != null || valMax != null) {
					// assume "character" counting type. Can also assume min/max properties are forced to match (DataAnnotations/TagHelpers handle that).
					type = "character";
					min = valMin ?? min;
					max = valMax ?? max;
					countOverflow = true;

				} else {
					// Use our pure JS port of jQuery's implementation.
					type = textArea.dataset.counterType ?? "";
					min = extractMinLength(textArea) ?? min;
					max = extractMaxLength(textArea) ?? max;
					countOverflow = textArea.dataset.counterOverflow === "true" ? true : false;
				}
				
				if (type !== "character" && type !== "word") {
					continue;
				}

				counter = new TextCounter(textArea, {
					type,
					min,
					max,
					countDown: true,
					countDownText: "%d %type(s) remaining",
					countOverflow,
					countSpaces: true,
					stopInputAtMaximum: !countOverflow,
					displayErrorText: false,
				});
				
				counter.init();

				// Delegate focus from the wrapper div to the textarea as appropriate.
				const dispose = delegateFocus(textArea, "div", { enableContainerStyle: false });
			}
		}
	})
}

/**
 * @param {HTMLTextAreaElement} textArea 
 * @returns {number?}
 */
function extractMaxLength(textArea) {
	let max = null;
	if (textArea.dataset.counterMaximum) {
		max = Number.parseInt(textArea.dataset.counterMaximum);
	}
	if (textArea.maxLength > 0) {
		if (max !== null && max > 0) {
			//textArea.maxLength = max;
		} else {
			max = textArea.maxLength;
		}
	}
	return max;
}

/**
 * @param {HTMLTextAreaElement} textArea 
 * @returns {number?}
 */
function extractMinLength(textArea) {
	let min = null;
	if (textArea.dataset.counterMinimum) {
		min = Number.parseInt(textArea.dataset.counterMinimum);
	}
	if (textArea.minLength > 0) {
		if (min !== null && min > 0) {
			//textArea.minLength = min;
		} else {
			min = textArea.minLength;
		}
	}
	return min;
}